import React from 'react';
import Navigation from '@/components/Navigation';
import HeroDemo from '@/components/Hero-demo';
import ProductsDemo from '@/components/Products-demo';
import AboutDemo from '@/components/About-demo';
import ContactDemo from '@/components/Contact-demo';
import Footer from '@/components/Footer';

const DemoPage = () => {
  return (
    <div className="min-h-screen bg-pearl-50">
      <Navigation />
      <main>
        <HeroDemo />
        <ProductsDemo />
        <AboutDemo />
        <ContactDemo />
      </main>
      <Footer />
    </div>
  );
};

export default DemoPage;
